import { gql } from "@apollo/client";

const FIELD_FRAGMENT = gql`
  fragment fieldFragment on FieldInput {
    display_name
    field_name
    default_string_value
    field_input_type
    field_input_size
    required
    disabled
  }
`;

export const GET_TICKET_PROVIDER_DEFINITIONS = gql`
  ${FIELD_FRAGMENT}
  query GetTicketProviderDefinitions {
    ticket_provider_definitions {
      edges {
        node {
          id
          type
          test_connection_supported
          instructions
          status
          sections {
            name
            rows {
              fields {
                ...fieldFragment
                options {
                  switch_cases {
                    label
                    name
                    value
                    rows {
                      fields {
                        ...fieldFragment
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const GET_TICKET_PROVIDERS = gql`
  ${FIELD_FRAGMENT}
  query GetTicketProviders($filters: TicketProviderFilter) {
    ticket_providers(filters: $filters) {
      edges {
        node {
          id
          type
          known_identifier
          display
          is_installed
          supports_editing
          instructions {
            title
            description
            link
            link_text
          }
          configuration
          sections {
            name
            rows {
              fields {
                ...fieldFragment
                options {
                  switch_cases {
                    label
                    name
                    value
                    rows {
                      fields {
                        ...fieldFragment
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const ADD_TICKET_PROVIDER = gql`
  mutation AddTicketProvider(
    $ticket_provider_type: TicketProviderTypeEnum
    $incoming_configuration: JSONString!
  ) {
    new_ticket_provider(
      ticket_provider_type: $ticket_provider_type
      incoming_configuration: $incoming_configuration
    ) {
      ticket_provider {
        id
        known_identifier
        is_installed
        instructions {
          title
          description
          link
          link_text
        }
        configuration
      }
    }
  }
`;

export const UPDATE_TICKET_PROVIDER = gql`
  mutation UpdateTicketProvider(
    $ticket_provider_id: String!
    $incoming_configuration: JSONString!
  ) {
    edit_ticket_provider(
      ticket_provider_id: $ticket_provider_id
      incoming_configuration: $incoming_configuration
    ) {
      ticket_provider {
        known_identifier
      }
    }
  }
`;

export const GET_TICKET_PROVIDER_CONNECTION = gql`
  query GetConnection($ticket_provider_id: Int!) {
    ticket_provider_integration_validation(
      ticket_provider_id: $ticket_provider_id
    ) {
      tests_results {
        permissions
        capabilities
        entity
        result
        error
      }
    }
  }
`;

export const OPEN_TEST_TICKET = gql`
  mutation openTestTicket(
    $ticket_provider_id: String!
    $value_mapping: JSONString
  ) {
    validate_open_ticket(
      ticket_provider_id: $ticket_provider_id
      value_mapping: $value_mapping
    ) {
      result {
        result
        error
      }
      ticket_link
      ticket_external_id
    }
  }
`;

export const GET_WEBHOOKS_TESTS = gql`
  query GetWebhookTests($ticket_provider_id: Int!) {
    ticket_provider_webhook_validation(
      ticket_provider_id: $ticket_provider_id
    ) {
      tests_results {
        ticket_id
        ticket_external_id
        ticket_link
        ticket_created_time
        ticket_provider_type
        result
        error
      }
    }
  }
`;
